var exports = {
  "k": "PrivacySafetyTabInline.module__container___WHJQRk",
};

module.exports = exports;
